// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoneView-module__font-s-10___F_dh9 {
  font-size: 10px !important;
}

.NoneView-module__font-s-12___m8kKI {
  font-size: 12px !important;
}

.NoneView-module__font-s-13___qJnDQ {
  font-size: 13px !important;
}

.NoneView-module__font-s-14___I4YY1 {
  font-size: 14px !important;
}

.NoneView-module__font-s-15___iORQw {
  font-size: 15px !important;
}

.NoneView-module__font-s-16___BfSL3 {
  font-size: 16px !important;
}

.NoneView-module__font-s-18____7FEL {
  font-size: 18px !important;
}

.NoneView-module__font-s-20___d8tiW {
  font-size: 20px !important;
}

.NoneView-module__font-s-22___lwzHs {
  font-size: 22px !important;
}

.NoneView-module__font-s-28___o8Vqn {
  font-size: 28px !important;
}

.NoneView-module__font-w-400___A5Q0L {
  font-weight: 400 !important;
}

.NoneView-module__font-w-500___BwY_g {
  font-weight: 500 !important;
}

.NoneView-module__font-w-600___mPneB {
  font-weight: 600 !important;
}

.NoneView-module__font-w-700___cf6sZ {
  font-weight: 700 !important;
}

.NoneView-module__p-5___KgTG1 {
  padding: 5px !important;
}

.NoneView-module__p-12___zSHkR {
  padding: 12px !important;
}

.NoneView-module__p-16___t11oE {
  padding: 16px !important;
}

.NoneView-module__p-30___p8i2P {
  padding: 30px !important;
}

.NoneView-module__p-b-0___dpePg {
  padding-bottom: 0 !important;
}

.NoneView-module__p-b-5___sVJho {
  padding-bottom: 5px !important;
}

.NoneView-module__p-b-10___A0vs4 {
  padding-bottom: 10px !important;
}

.NoneView-module__p-b-12___Rk0dR {
  padding-bottom: 12px !important;
}

.NoneView-module__p-b-16___HAfe0 {
  padding-bottom: 16px !important;
}

.NoneView-module__p-b-18___En12o {
  padding-bottom: 18px !important;
}

.NoneView-module__p-b-20___SDseJ {
  padding-bottom: 20px !important;
}

.NoneView-module__p-b-25___peJsP {
  padding-bottom: 25px !important;
}

.NoneView-module__p-b-30___p2hqw {
  padding-bottom: 30px !important;
}

.NoneView-module__p-b-50___asZIC {
  padding-bottom: 50px !important;
}

.NoneView-module__p-t-0___qF_eh {
  padding-top: 0 !important;
}

.NoneView-module__p-t-12___LLOod {
  padding-top: 12px !important;
}

.NoneView-module__p-t-16___JDvi4 {
  padding-top: 16px !important;
}

.NoneView-module__p-t-18___wOiQ_ {
  padding-top: 18px !important;
}

.NoneView-module__p-t-20___cIqqb {
  padding-top: 20px !important;
}

.NoneView-module__p-t-30___pNhls {
  padding-top: 30px !important;
}

.NoneView-module__p-t-40___rZc4C {
  padding-top: 40px !important;
}

.NoneView-module__p-t-50___yNvLA {
  padding-top: 50px !important;
}

.NoneView-module__p-l-20___lt2tA {
  padding-left: 20px !important;
}

.NoneView-module__p-l-30___DzFdK {
  padding-left: 30px !important;
}

.NoneView-module__p-l-40____wofy {
  padding-left: 40px !important;
}

.NoneView-module__p-r-16___y8gB0 {
  padding-right: 16px !important;
}

.NoneView-module__p-r-20___fj_w5 {
  padding-right: 20px !important;
}

.NoneView-module__p-r-30___EEg8Y {
  padding-right: 30px !important;
}

.NoneView-module__p-r-50___RyJjL {
  padding-right: 50px !important;
}

.NoneView-module__p-r-60___YI2JR {
  padding-right: 60px !important;
}

.NoneView-module__m-b-1___fP4RT {
  margin-bottom: 1px !important;
}

.NoneView-module__m-b-2___jx58v {
  margin-bottom: 2px !important;
}

.NoneView-module__m-b-6___zLDmz {
  margin-bottom: 6px !important;
}

.NoneView-module__m-b-8___Fsl2E {
  margin-bottom: 8px !important;
}

.NoneView-module__m-b-10___wGfVb {
  margin-bottom: 10px !important;
}

.NoneView-module__m-b-14___HJyBP {
  margin-bottom: 14px !important;
}

.NoneView-module__m-b-16___OzBT_ {
  margin-bottom: 16px !important;
}

.NoneView-module__m-b-20___BiU_Y {
  margin-bottom: 20px !important;
}

.NoneView-module__m-b-22___NWdW0 {
  margin-bottom: 22px !important;
}

.NoneView-module__m-b-24___wFmJl {
  margin-bottom: 24px !important;
}

.NoneView-module__m-b-30___r2sGL {
  margin-bottom: 30px !important;
}

.NoneView-module__m-b-32___n7lt0 {
  margin-bottom: 32px !important;
}

.NoneView-module__m-b-40___oyRuO {
  margin-bottom: 40px !important;
}

.NoneView-module__m-t-2___KNet1 {
  margin-top: 2px !important;
}

.NoneView-module__m-t-3___sXeau {
  margin-top: 3px !important;
}

.NoneView-module__m-t-4___Ur0_T {
  margin-top: 4px !important;
}

.NoneView-module__m-t-5___y2YIM {
  margin-top: 5px !important;
}

.NoneView-module__m-t-8___nMmkp {
  margin-top: 8px !important;
}

.NoneView-module__m-t-10___KOZYr {
  margin-top: 10px !important;
}

.NoneView-module__m-t-15___byMTu {
  margin-top: 15px !important;
}

.NoneView-module__m-t-16___m9Fe1 {
  margin-top: 16px !important;
}

.NoneView-module__m-t-20___oRO_3 {
  margin-top: 20px !important;
}

.NoneView-module__m-t-22___Jw_Lh {
  margin-top: 22px !important;
}

.NoneView-module__m-t-30___U5BkA {
  margin-top: 30px !important;
}

.NoneView-module__m-t-32___eVIhE {
  margin-top: 32px !important;
}

.NoneView-module__m-l-auto____jMRG {
  margin-left: auto !important;
}

.NoneView-module__m-l-4___FylxR {
  margin-left: 4px !important;
}

.NoneView-module__m-l-5___BoDwj {
  margin-left: 5px !important;
}

.NoneView-module__m-l-6___jqggl {
  margin-left: 6px !important;
}

.NoneView-module__m-l-8___qwDdj {
  margin-left: 8px !important;
}

.NoneView-module__m-l-10___PIw6V {
  margin-left: 10px !important;
}

.NoneView-module__m-l-16___opVxP {
  margin-left: 16px !important;
}

.NoneView-module__m-l-20___HmSK3 {
  margin-left: 20px !important;
}

.NoneView-module__m-l-24___NHw2i {
  margin-left: 24px !important;
}

.NoneView-module__m-l-30___ww_uB {
  margin-left: 30px !important;
}

.NoneView-module__m-l-35___TEb2_ {
  margin-left: 35px !important;
}

.NoneView-module__m-l-40___ZZ5oI {
  margin-left: 40px !important;
}

.NoneView-module__m-r-8___KswKb {
  margin-right: 8px !important;
}

.NoneView-module__m-r-10___ucynj {
  margin-right: 10px !important;
}

.NoneView-module__m-r-16___GibgQ {
  margin-right: 16px !important;
}

.NoneView-module__m-r-20___lUb9N {
  margin-right: 20px !important;
}

.NoneView-module__m-r-24___f8C8D {
  margin-right: 24px !important;
}

.NoneView-module__m-r-30___wAfTw {
  margin-right: 30px !important;
}

.NoneView-module__m-r-40___u4Po1 {
  margin-right: 40px !important;
}

.NoneView-module__border-r-3___Gc53F {
  border-radius: 3px !important;
}

.NoneView-module__border-r-4___NuZc0 {
  border-radius: 4px !important;
}

.NoneView-module__border-r-6___JUqGM {
  border-radius: 6px !important;
}

.NoneView-module__border-r-10___Ls1ks {
  border-radius: 10px !important;
}

.NoneView-module__border-r-12___qrKWq {
  border-radius: 12px !important;
}

.NoneView-module__border-r-16___b98jW {
  border-radius: 16px !important;
}

.NoneView-module__border-r-50___LoiXA {
  border-radius: 50% !important;
}

.NoneView-module__primary-border___GZR57 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.NoneView-module__primary-border-b___vUNZj {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.NoneView-module__primary-border-t___yFhcN {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.NoneView-module__primary-border-l___ojrIN {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.NoneView-module__primary-border-r___v5R7K {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.NoneView-module__secondary-border___etMPg {
  border: 1px solid #637768;
}

.NoneView-module__secondary-border-b___JXRXD {
  border-bottom: 1px solid #637768;
}

.NoneView-module__secondary-border-t___UF0kU {
  border-top: 1px solid #637768;
}

.NoneView-module__secondary-border-l___ZaNgI {
  border-left: 1px solid #637768;
}

.NoneView-module__secondary-border-r___uNohK {
  border-right: 1px solid #637768;
}

.NoneView-module__gap-0___je_Uk {
  gap: 0 !important;
}

.NoneView-module__gap-2___AuEzf {
  gap: 2px !important;
}

.NoneView-module__gap-4___AbWQZ {
  gap: 4px !important;
}

.NoneView-module__gap-5___JR9uI {
  gap: 5px !important;
}

.NoneView-module__gap-6___wxqPt {
  gap: 6px !important;
}

.NoneView-module__gap-8___EuwVl {
  gap: 8px !important;
}

.NoneView-module__gap-10___SY4CB {
  gap: 10px !important;
}

.NoneView-module__gap-12___rmBe3 {
  gap: 12px !important;
}

.NoneView-module__gap-14___H_z4M {
  gap: 14px !important;
}

.NoneView-module__gap-16___HVD3c {
  gap: 16px !important;
}

.NoneView-module__gap-18___CEziu {
  gap: 18px !important;
}

.NoneView-module__gap-20___p88bE {
  gap: 20px !important;
}

.NoneView-module__gap-24___VH_VG {
  gap: 24px !important;
}

.NoneView-module__gap-26___H7ieF {
  gap: 26px !important;
}

.NoneView-module__gap-30___kSK9v {
  gap: 30px !important;
}

.NoneView-module__gap-32___Kal5H {
  gap: 32px !important;
}

.NoneView-module__gap-40___EyyoB {
  gap: 40px !important;
}

.NoneView-module__gap-50___huTjL {
  gap: 50px !important;
}

.NoneView-module__flex-1___s8Rum {
  flex: 1;
}

.NoneView-module__flex-none___Or2pB {
  flex: none !important;
}

.NoneView-module__flex-column___bWpW8 {
  display: flex;
  flex-direction: column !important;
}

.NoneView-module__flex-row___CerMC {
  display: flex;
  flex-direction: row !important;
}

.NoneView-module__vertically-centered___K00DY {
  display: flex;
  align-items: center !important;
}

.NoneView-module__horizontally-centered___I_zN_ {
  display: flex;
  justify-content: center !important;
}

.NoneView-module__horizontally-end___CJwFt {
  display: flex;
  justify-content: end !important;
}

.NoneView-module__vertically-start___td50T {
  display: flex;
  align-items: start !important;
}

.NoneView-module__space-between___XkZU_ {
  display: flex;
  justify-content: space-between !important;
}

.NoneView-module__flex-wrap___NuVvl {
  flex-wrap: wrap !important;
}

.NoneView-module__height-100___QsDo2 {
  height: 100%;
}

.NoneView-module__width-50___zMkj4 {
  width: 50% !important;
}

.NoneView-module__width-100___vgkU8 {
  width: 100%;
}

.NoneView-module__cursor-pointer___dWN6Y {
  cursor: pointer;
}

.NoneView-module__cursor-not-allowed___0wgrT {
  cursor: not-allowed !important;
}

.NoneView-module__absolute-centered___hsV6y {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.NoneView-module__absolute___mSIPS {
  position: absolute;
}

.NoneView-module__relative___JawLG {
  position: relative;
}

.NoneView-module__fixed___dl8T_ {
  position: fixed;
}

.NoneView-module__visible___Vn_4Q {
  opacity: 1;
}

.NoneView-module__invisible___jZeCt {
  opacity: 0;
}

.NoneView-module__col-90___lRris {
  width: 90% !important;
}

.NoneView-module__col-auto___EK0Sq {
  width: auto !important;
}

.NoneView-module__medical-tabs___ShGZd {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.NoneView-module__medical-table-new___ZQ4T1 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NoneView-module__medical-table-new___ZQ4T1:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NoneView-module__medical-table-new___ZQ4T1::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NoneView-module__medical-table-new___ZQ4T1::-webkit-scrollbar-track {
  display: none;
}
.NoneView-module__medical-table-new___ZQ4T1.NoneView-module__no-pagination___gPqfG {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NoneView-module__medical-table-new___ZQ4T1.NoneView-module__no-pagination___gPqfG:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NoneView-module__medical-table-new___ZQ4T1.NoneView-module__no-pagination___gPqfG::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NoneView-module__medical-table-new___ZQ4T1.NoneView-module__no-pagination___gPqfG::-webkit-scrollbar-track {
  display: none;
}

.NoneView-module__medical-table-empty___iDQff {
  padding: 14px 40px !important;
}

.NoneView-module__icon-btn___ccNZK {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.NoneView-module__search-icon___jnEF7 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.NoneView-module__disable-select___YgZaQ {
  user-select: none;
}

.NoneView-module__break-word___ir7lT {
  word-break: break-word;
}

.NoneView-module__popup-clear-btn___hn9Pn {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.NoneView-module__scroll-m-b-20___Z5JQ6 {
  scroll-margin-bottom: 20px;
}

.NoneView-module__container___wfPgQ {
  flex: 1;
}
.NoneView-module__container___wfPgQ .NoneView-module__noneTextSmall___kD70c,
.NoneView-module__container___wfPgQ .NoneView-module__noneTextMedium___CAbKi,
.NoneView-module__container___wfPgQ .NoneView-module__noneTextLarge___AVcsc {
  text-align: center;
  padding: 10px 0;
}
.NoneView-module__container___wfPgQ .NoneView-module__noneTextSmall___kD70c {
  font-family: var(--font-family);
  font-weight: 900;
  font-size: 0.9rem;
  color: #375844;
}
.NoneView-module__container___wfPgQ .NoneView-module__noneTextMedium___CAbKi {
  font-family: var(--font-family);
  font-weight: 900;
  font-size: 1rem;
  color: #375844;
}
.NoneView-module__container___wfPgQ .NoneView-module__noneTextLarge___AVcsc {
  font-family: var(--font-family);
  font-weight: 900;
  font-size: 1.2rem;
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/elements/NoneView/NoneView.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;AA8pBF;AA5pBE;;;EAGE,kBAAA;EACA,eAAA;AA8pBJ;AA3pBE;EEcA,+BApBO;EAqBP,gBCrBM;EDsBN,iBAAA;EFdE,cAAA;AA+pBJ;AA5pBE;EESA,+BApBO;EAqBP,gBCrBM;EDsBN,eAAA;EFTE,cAAA;AAgqBJ;AA7pBE;EEIA,+BApBO;EAqBP,gBCrBM;EDsBN,iBAAA;EFJE,cAAA;AAiqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n\n  .noneTextSmall,\n  .noneTextMedium,\n  .noneTextLarge {\n    text-align: center;\n    padding: $row-padding-vertical 0;\n  }\n\n  .noneTextSmall {\n    @include get-font($roboto, $heavy, small);\n    color: get-color(greenNew, dark);\n  }\n\n  .noneTextMedium {\n    @include get-font($roboto, $heavy, medium);\n    color: get-color(greenNew, dark);\n  }\n\n  .noneTextLarge {\n    @include get-font($roboto, $heavy, large);\n    color: get-color(greenNew, dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `NoneView-module__font-s-10___F_dh9`,
	"fontS12": `NoneView-module__font-s-12___m8kKI`,
	"fontS13": `NoneView-module__font-s-13___qJnDQ`,
	"fontS14": `NoneView-module__font-s-14___I4YY1`,
	"fontS15": `NoneView-module__font-s-15___iORQw`,
	"fontS16": `NoneView-module__font-s-16___BfSL3`,
	"fontS18": `NoneView-module__font-s-18____7FEL`,
	"fontS20": `NoneView-module__font-s-20___d8tiW`,
	"fontS22": `NoneView-module__font-s-22___lwzHs`,
	"fontS28": `NoneView-module__font-s-28___o8Vqn`,
	"fontW400": `NoneView-module__font-w-400___A5Q0L`,
	"fontW500": `NoneView-module__font-w-500___BwY_g`,
	"fontW600": `NoneView-module__font-w-600___mPneB`,
	"fontW700": `NoneView-module__font-w-700___cf6sZ`,
	"p5": `NoneView-module__p-5___KgTG1`,
	"p12": `NoneView-module__p-12___zSHkR`,
	"p16": `NoneView-module__p-16___t11oE`,
	"p30": `NoneView-module__p-30___p8i2P`,
	"pB0": `NoneView-module__p-b-0___dpePg`,
	"pB5": `NoneView-module__p-b-5___sVJho`,
	"pB10": `NoneView-module__p-b-10___A0vs4`,
	"pB12": `NoneView-module__p-b-12___Rk0dR`,
	"pB16": `NoneView-module__p-b-16___HAfe0`,
	"pB18": `NoneView-module__p-b-18___En12o`,
	"pB20": `NoneView-module__p-b-20___SDseJ`,
	"pB25": `NoneView-module__p-b-25___peJsP`,
	"pB30": `NoneView-module__p-b-30___p2hqw`,
	"pB50": `NoneView-module__p-b-50___asZIC`,
	"pT0": `NoneView-module__p-t-0___qF_eh`,
	"pT12": `NoneView-module__p-t-12___LLOod`,
	"pT16": `NoneView-module__p-t-16___JDvi4`,
	"pT18": `NoneView-module__p-t-18___wOiQ_`,
	"pT20": `NoneView-module__p-t-20___cIqqb`,
	"pT30": `NoneView-module__p-t-30___pNhls`,
	"pT40": `NoneView-module__p-t-40___rZc4C`,
	"pT50": `NoneView-module__p-t-50___yNvLA`,
	"pL20": `NoneView-module__p-l-20___lt2tA`,
	"pL30": `NoneView-module__p-l-30___DzFdK`,
	"pL40": `NoneView-module__p-l-40____wofy`,
	"pR16": `NoneView-module__p-r-16___y8gB0`,
	"pR20": `NoneView-module__p-r-20___fj_w5`,
	"pR30": `NoneView-module__p-r-30___EEg8Y`,
	"pR50": `NoneView-module__p-r-50___RyJjL`,
	"pR60": `NoneView-module__p-r-60___YI2JR`,
	"mB1": `NoneView-module__m-b-1___fP4RT`,
	"mB2": `NoneView-module__m-b-2___jx58v`,
	"mB6": `NoneView-module__m-b-6___zLDmz`,
	"mB8": `NoneView-module__m-b-8___Fsl2E`,
	"mB10": `NoneView-module__m-b-10___wGfVb`,
	"mB14": `NoneView-module__m-b-14___HJyBP`,
	"mB16": `NoneView-module__m-b-16___OzBT_`,
	"mB20": `NoneView-module__m-b-20___BiU_Y`,
	"mB22": `NoneView-module__m-b-22___NWdW0`,
	"mB24": `NoneView-module__m-b-24___wFmJl`,
	"mB30": `NoneView-module__m-b-30___r2sGL`,
	"mB32": `NoneView-module__m-b-32___n7lt0`,
	"mB40": `NoneView-module__m-b-40___oyRuO`,
	"mT2": `NoneView-module__m-t-2___KNet1`,
	"mT3": `NoneView-module__m-t-3___sXeau`,
	"mT4": `NoneView-module__m-t-4___Ur0_T`,
	"mT5": `NoneView-module__m-t-5___y2YIM`,
	"mT8": `NoneView-module__m-t-8___nMmkp`,
	"mT10": `NoneView-module__m-t-10___KOZYr`,
	"mT15": `NoneView-module__m-t-15___byMTu`,
	"mT16": `NoneView-module__m-t-16___m9Fe1`,
	"mT20": `NoneView-module__m-t-20___oRO_3`,
	"mT22": `NoneView-module__m-t-22___Jw_Lh`,
	"mT30": `NoneView-module__m-t-30___U5BkA`,
	"mT32": `NoneView-module__m-t-32___eVIhE`,
	"mLAuto": `NoneView-module__m-l-auto____jMRG`,
	"mL4": `NoneView-module__m-l-4___FylxR`,
	"mL5": `NoneView-module__m-l-5___BoDwj`,
	"mL6": `NoneView-module__m-l-6___jqggl`,
	"mL8": `NoneView-module__m-l-8___qwDdj`,
	"mL10": `NoneView-module__m-l-10___PIw6V`,
	"mL16": `NoneView-module__m-l-16___opVxP`,
	"mL20": `NoneView-module__m-l-20___HmSK3`,
	"mL24": `NoneView-module__m-l-24___NHw2i`,
	"mL30": `NoneView-module__m-l-30___ww_uB`,
	"mL35": `NoneView-module__m-l-35___TEb2_`,
	"mL40": `NoneView-module__m-l-40___ZZ5oI`,
	"mR8": `NoneView-module__m-r-8___KswKb`,
	"mR10": `NoneView-module__m-r-10___ucynj`,
	"mR16": `NoneView-module__m-r-16___GibgQ`,
	"mR20": `NoneView-module__m-r-20___lUb9N`,
	"mR24": `NoneView-module__m-r-24___f8C8D`,
	"mR30": `NoneView-module__m-r-30___wAfTw`,
	"mR40": `NoneView-module__m-r-40___u4Po1`,
	"borderR3": `NoneView-module__border-r-3___Gc53F`,
	"borderR4": `NoneView-module__border-r-4___NuZc0`,
	"borderR6": `NoneView-module__border-r-6___JUqGM`,
	"borderR10": `NoneView-module__border-r-10___Ls1ks`,
	"borderR12": `NoneView-module__border-r-12___qrKWq`,
	"borderR16": `NoneView-module__border-r-16___b98jW`,
	"borderR50": `NoneView-module__border-r-50___LoiXA`,
	"primaryBorder": `NoneView-module__primary-border___GZR57`,
	"primaryBorderB": `NoneView-module__primary-border-b___vUNZj`,
	"primaryBorderT": `NoneView-module__primary-border-t___yFhcN`,
	"primaryBorderL": `NoneView-module__primary-border-l___ojrIN`,
	"primaryBorderR": `NoneView-module__primary-border-r___v5R7K`,
	"secondaryBorder": `NoneView-module__secondary-border___etMPg`,
	"secondaryBorderB": `NoneView-module__secondary-border-b___JXRXD`,
	"secondaryBorderT": `NoneView-module__secondary-border-t___UF0kU`,
	"secondaryBorderL": `NoneView-module__secondary-border-l___ZaNgI`,
	"secondaryBorderR": `NoneView-module__secondary-border-r___uNohK`,
	"gap0": `NoneView-module__gap-0___je_Uk`,
	"gap2": `NoneView-module__gap-2___AuEzf`,
	"gap4": `NoneView-module__gap-4___AbWQZ`,
	"gap5": `NoneView-module__gap-5___JR9uI`,
	"gap6": `NoneView-module__gap-6___wxqPt`,
	"gap8": `NoneView-module__gap-8___EuwVl`,
	"gap10": `NoneView-module__gap-10___SY4CB`,
	"gap12": `NoneView-module__gap-12___rmBe3`,
	"gap14": `NoneView-module__gap-14___H_z4M`,
	"gap16": `NoneView-module__gap-16___HVD3c`,
	"gap18": `NoneView-module__gap-18___CEziu`,
	"gap20": `NoneView-module__gap-20___p88bE`,
	"gap24": `NoneView-module__gap-24___VH_VG`,
	"gap26": `NoneView-module__gap-26___H7ieF`,
	"gap30": `NoneView-module__gap-30___kSK9v`,
	"gap32": `NoneView-module__gap-32___Kal5H`,
	"gap40": `NoneView-module__gap-40___EyyoB`,
	"gap50": `NoneView-module__gap-50___huTjL`,
	"flex1": `NoneView-module__flex-1___s8Rum`,
	"flexNone": `NoneView-module__flex-none___Or2pB`,
	"flexColumn": `NoneView-module__flex-column___bWpW8`,
	"flexRow": `NoneView-module__flex-row___CerMC`,
	"verticallyCentered": `NoneView-module__vertically-centered___K00DY`,
	"horizontallyCentered": `NoneView-module__horizontally-centered___I_zN_`,
	"horizontallyEnd": `NoneView-module__horizontally-end___CJwFt`,
	"verticallyStart": `NoneView-module__vertically-start___td50T`,
	"spaceBetween": `NoneView-module__space-between___XkZU_`,
	"flexWrap": `NoneView-module__flex-wrap___NuVvl`,
	"height100": `NoneView-module__height-100___QsDo2`,
	"width50": `NoneView-module__width-50___zMkj4`,
	"width100": `NoneView-module__width-100___vgkU8`,
	"cursorPointer": `NoneView-module__cursor-pointer___dWN6Y`,
	"cursorNotAllowed": `NoneView-module__cursor-not-allowed___0wgrT`,
	"absoluteCentered": `NoneView-module__absolute-centered___hsV6y`,
	"absolute": `NoneView-module__absolute___mSIPS`,
	"relative": `NoneView-module__relative___JawLG`,
	"fixed": `NoneView-module__fixed___dl8T_`,
	"visible": `NoneView-module__visible___Vn_4Q`,
	"invisible": `NoneView-module__invisible___jZeCt`,
	"col90": `NoneView-module__col-90___lRris`,
	"colAuto": `NoneView-module__col-auto___EK0Sq`,
	"medicalTabs": `NoneView-module__medical-tabs___ShGZd`,
	"medicalTableNew": `NoneView-module__medical-table-new___ZQ4T1`,
	"noPagination": `NoneView-module__no-pagination___gPqfG`,
	"medicalTableEmpty": `NoneView-module__medical-table-empty___iDQff`,
	"iconBtn": `NoneView-module__icon-btn___ccNZK`,
	"searchIcon": `NoneView-module__search-icon___jnEF7`,
	"disableSelect": `NoneView-module__disable-select___YgZaQ`,
	"breakWord": `NoneView-module__break-word___ir7lT`,
	"popupClearBtn": `NoneView-module__popup-clear-btn___hn9Pn`,
	"scrollMB20": `NoneView-module__scroll-m-b-20___Z5JQ6`,
	"container": `NoneView-module__container___wfPgQ`,
	"noneTextSmall": `NoneView-module__noneTextSmall___kD70c`,
	"noneTextMedium": `NoneView-module__noneTextMedium___CAbKi`,
	"noneTextLarge": `NoneView-module__noneTextLarge___AVcsc`
};
module.exports = ___CSS_LOADER_EXPORT___;
